import { DonationData } from "@/types/donation";

const STORAGE_KEY = "donation";

export const getDonationData = (ongId: number) => {
  let storageDonation: DonationData[] =
    window?.localStorage && window.localStorage.getItem(STORAGE_KEY)
      ? JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]")
      : [];

  if (!Array.isArray(storageDonation)) {
    storageDonation = [];
  }

  const donationData = storageDonation.find(
    (item: any) => item.ongId === ongId
  );

  return donationData as DonationData;
};

export const getDonationDataArray = () => {
  try {
    let storageDonation: DonationData[] | [] =
      window?.localStorage && window.localStorage.getItem(STORAGE_KEY)
        ? JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]")
        : [];

    return storageDonation || [];
  } catch (error) {
    console.error("Error getting donation data from localStorage:", error);
    return [];
  }
};

export const getCartID = (ongId: number): string => {
  try {
    let storageDonation: DonationData[] | undefined =
      window?.localStorage && window.localStorage.getItem(STORAGE_KEY)
        ? JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]")
        : [];

    if (!Array.isArray(storageDonation)) {
      storageDonation = [];
    }

    const donationData = storageDonation.find(
      (item: any) => item.ongId === ongId
    );

    return donationData?.cartID || "";
  } catch (error) {
    console.error("Error getting cartID from localStorage:", error);
    return "";
  }
};
